import React from 'react'
import './NavBar.css'
import LanguageControl from './LanguageControl'

const NavBar = () => {
    return (
        <nav>
            <div className="logo">
                <span>gabriel@site</span>
            </div>
            <LanguageControl></LanguageControl>
        </nav>
    )
}

export default NavBar
